import React, { useState } from "react";
import Table from "../UserDashboard/Table";
import SideBar from "./SideBar";
import { toast } from "react-hot-toast";
import { Empty } from "../UserDashboard/Notifications/Error";
import { useDispatch, useSelector } from "react-redux";
// import {
//   deleteAllOrdersAction,
//   getAllOrdersAction,
// } from '../../Redux/Actions/OrderAction';
// import { Loader } from '../../components/Notifications/Loader';
import BigLoader from "../UserDashboard/Notifications/BigLoader";
import orderData from "./data";
import bookingApi from "../../api/booking/BookingApi";
import { useEffect } from "react";
import Loading from "../../Util/Loading";
import ProcessingBar from "../../Util/Processingbar";
import { useNavigate, useParams } from "react-router-dom";
import { AiFillStar } from "react-icons/ai";
import ConfirmDialog from "./ConfirmDialog";

function BookingDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const [booking, setBooking] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getBookingDetail = async () => {
    try {
      const { response } = await bookingApi.getBookingById({ id });
      if (response?.data?.booking) {
        setBooking(response.data.booking);
      } else {
        toast.error("Booking not found");
        navigate("/appointments");
      }
    } catch (error) {
      toast.error("Error loading booking");
      console.error(error);
      navigate("/appointments");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await Promise.all([getBookingDetail()]);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  {
    console.log({ booking });
  }

  // // delete all orders
  const deleteAllOrdersHandler = () => {
    if (window.confirm("All orders will be deleted")) {
      // dispatch(deleteAllOrdersAction());
      alert("delete all");
    }
  };

  const loading = false;

  const extractMinutes = (desc) => {
    const lower = desc?.toLowerCase() || "";
    const hrMatch = lower.match(/(\d+)\s*hr/);
    const minMatch = lower.match(/(\d+)\s*min/);
    const hr = hrMatch ? parseInt(hrMatch[1], 10) : 0;
    const min = minMatch ? parseInt(minMatch[1], 10) : 0;
    return hr * 60 + min;
  };

  const formatDuration = (mins) => {
    const hours = Math.floor(mins / 60);
    const minutes = mins % 60;
    if (hours && minutes) return `${hours} hr ${minutes} mins`;
    if (hours) return `${hours} hr`;
    return `${minutes} mins`;
  };

  const {
    customer_info,
    selectedNailServices,
    selectedBeautyServices,
    selectedProfessional,
    selectedDateTime,
    note,
  } = booking;
  const [showConfirm, setShowConfirm] = useState(false);

  const isCancelled = booking?.booking?.status === "cancelled";
  const isPast =
    selectedDateTime && new Date(selectedDateTime).getTime() < Date.now();

  const SectionCard = ({ title, children }) => (
    <div className="bg-white/10 p-4 rounded-2xl shadow border border-border">
      <h4 className="text-sm font-medium text-gray-400 uppercase tracking-wider mb-2">
        {title}
      </h4>
      <div>{children}</div>
    </div>
  );

  const renderServiceListWithTime = (services) => {
    if (!services.length)
      return <p className="text-base text-gray-400 italic">None selected</p>;

    const totalMins = services.reduce(
      (acc, s) => acc + extractMinutes(s.desc),
      0
    );

    return (
      <>
        {services.map((item, i) => (
          <div key={i} className="flex items-start space-x-2 mb-2">
            <div className="w-6 h-6 bg-yellowlight rounded-md flex items-center justify-center mt-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4 text-yellowdark"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <p className="text-lg font-semibold text-white">
              {item.title}
              {item.desc && (
                <span className="text-sm text-gray-400"> ({item.desc})</span>
              )}
            </p>
          </div>
        ))}
        <p className="text-right text-yellowlight font-medium mt-2">
          Total: {formatDuration(totalMins)}
        </p>
      </>
    );
  };

  const formatDateTime = (dateStr) => {
    const date = new Date(dateStr);
    if (isNaN(date)) return dateStr;

    return new Intl.DateTimeFormat("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    }).format(date);
  };

  const cancelBookingHandler = () => {
    setShowConfirm(true);
  };

  const confirmCancel = async () => {
    setShowConfirm(false);
    try {
      const { response, err } = await bookingApi.cancelBooking({ id });
      if (err) throw err;
      toast.success("Booking cancelled successfully");
      navigate("/dashboard");
    } catch (error) {
      toast.error("Failed to cancel booking");
      console.error(error);
    }
  };

  const modifyBookingHandler = () => {
    navigate(`/reschedule/${id}`); // or your edit page route
  };

  const handleReactivate = async () => {
    try {
      const { response, err } = await bookingApi.reactivateBooking({ id });
      if (err) throw err;
      toast.success("Booking reactivated!");
      getBookingDetail(); // refetch updated data
      navigate("/dashboard");
    } catch (error) {
      toast.error("Failed to reactivate");
      console.error(error);
    }
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <SideBar>
      {showConfirm && (
        <ConfirmDialog
          message="Are you sure you want to cancel this booking?"
          onConfirm={confirmCancel}
          onCancel={() => setShowConfirm(false)}
        />
      )}
      {loading ? (
        <div className="flex-colo h-96">
          <Loading />
        </div>
      ) : (
        <div className="max-w-4xl mx-auto p-1 text-white space-y-6">
          <h2 className="text-2xl font-bold text-yellowlight border-b border-border pb-4">
            Appointment Details
          </h2>

          <SectionCard title="Nail Services">
            {renderServiceListWithTime(selectedNailServices)}
          </SectionCard>

          <SectionCard title="Beauty Services">
            {renderServiceListWithTime(selectedBeautyServices)}
          </SectionCard>

          <SectionCard title="Professional">
            {selectedProfessional ? (
              <div className="flex items-center space-x-3 mt-2">
                <img
                  src={selectedProfessional?.photo || "/default-avatar.png"}
                  alt={selectedProfessional.name}
                  className="w-10 h-10 rounded-full object-cover border border-yellowlight"
                />
                <div className="flex flex-col">
                  <p className="text-lg font-semibold text-white">
                    {selectedProfessional.name}
                  </p>
                  {selectedProfessional.role && (
                    <p className="text-sm text-gray-400">
                      {selectedProfessional.role}
                    </p>
                  )}
                  {/* <span className="flex items-center text-yellow-400 text-sm mt-1">
                    <AiFillStar className="mr-1" />
                  </span> */}
                </div>
              </div>
            ) : (
              <p className="text-base text-gray-400 italic">
                No professional assigned
              </p>
            )}
          </SectionCard>

          <SectionCard title="Appointment Time">
            <p className="text-lg font-semibold text-white">
              {formatDateTime(selectedDateTime)}
            </p>
          </SectionCard>

          <SectionCard title="Customer Info">
            <ul className="space-y-1">
              <li>
                <span className="text-sm text-gray-400">Name:</span>{" "}
                <span className="text-lg font-semibold text-white">
                  {customer_info?.name || "—"}
                </span>
              </li>
              <li>
                <span className="text-sm text-gray-400">Email:</span>{" "}
                <span className="text-lg font-semibold text-white">
                  {customer_info?.email || "—"}
                </span>
              </li>
              <li>
                <span className="text-sm text-gray-400">Phone:</span>{" "}
                <span className="text-lg font-semibold text-white">
                  {customer_info?.mobile || "—"}
                </span>
              </li>
            </ul>
          </SectionCard>

          <SectionCard title="Notes">
            <p className="text-lg font-semibold text-white whitespace-pre-line break-words">
              {customer_info?.message || "—"}
            </p>
          </SectionCard>
          <div className="pt-6 border-t border-border">
            {isCancelled ? (
              <button
                onClick={handleReactivate}
                className="w-full px-6 py-3 bg-yellowlight hover:bg-yellowdark text-black rounded-2xl font-semibold text-lg shadow"
              >
                Reactive Your Appointment
              </button>
            ) : isPast ? (
              <div className="bg-white/10 text-yellowlight text-sm sm:text-base p-4 rounded-2xl shadow border border-border text-center">
                <p className="font-semibold text-lg mb-1">
                  Cam not rebook your appointment
                </p>
                <p>
                  Sorry, the appointment date has already passed and can't be
                  modified.
                  <br className="mb-4" />
                </p>
                <button
                  onClick={() => navigate("/")}
                  className="m-3 px-6 py-3 bg-yellowlight hover:bg-yellowdark hover:text-yellowlight text-yellowdark rounded-2xl font-semibold text-lg shadow"
                >
                  New Appointment
                </button>
              </div>
            ) : (
              <div className="flex flex-col sm:flex-row gap-4">
                <button
                  onClick={cancelBookingHandler}
                  className="w-full px-6 py-3 bg-red-600 hover:bg-red-700 text-white rounded-2xl font-semibold text-lg shadow"
                >
                  Cancel Booking
                </button>

                <button
                  onClick={modifyBookingHandler}
                  className="w-full px-6 py-3 bg-yellowlight hover:bg-yellowdark hover:text-yellowlight text-yellowdark rounded-2xl font-semibold text-lg shadow"
                >
                  Modify Booking
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </SideBar>
  );
}

export default BookingDetail;
